var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.0335 1.66406C11.4252 1.66406 11.7502 1.98073 11.7502 2.38073V17.6224C11.7502 18.0141 11.4335 18.3391 11.0335 18.3391C6.1252 18.3391 2.7002 14.9141 2.7002 10.0057C2.7002 5.0974 6.13353 1.66406 11.0335 1.66406Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1169 9.61875L14.7502 7.24375C14.5086 7.00208 14.1086 7.00208 13.8669 7.24375C13.6252 7.48542 13.6252 7.88542 13.8669 8.12708L15.1669 9.42708H7.19189C6.85023 9.42708 6.56689 9.71042 6.56689 10.0521C6.56689 10.3938 6.85023 10.6771 7.19189 10.6771H15.1669L13.8669 11.9771C13.6252 12.2188 13.6252 12.6188 13.8669 12.8604C13.9919 12.9854 14.1502 13.0438 14.3086 13.0438C14.4669 13.0438 14.6252 12.9854 14.7502 12.8604L17.1169 10.4854C17.3586 10.2521 17.3586 9.86042 17.1169 9.61875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutLight);
export default __webpack_public_path__ + "static/media/logout_light.0cf33bfd2b3bf3e27ec800ed8c80b328.svg";
export { ForwardRef as ReactComponent };